<template>
  <div class="layout">
    <div class="layout_con">
      <top-bar :title="`红色遗迹-${detailsInfo.name}`"></top-bar>
      <div class="top_info">
        <img class="item_img" :src="`${STATIC}${detailsInfo.image}`" alt="" />
      </div>
      <div class="title">
        <div class="item_title">
          中共西安地位第一部委及 长安县农协遗址
        </div>
        <img src="@/assets/img/common/title_embellish2.png" alt="" />
      </div>
      <div class="item_content" v-html="detailsInfo.content"></div>
    </div>
  </div>
</template>

<script>
import topBar from '@/components/topBar/index'
import qs from 'qs'
import { STATIC } from '@/request/index.js'
export default {
  metaInfo: {
    title: '具相长安-红色记忆'
  },
  components: {
    topBar
  },
  data() {
    return {
      STATIC: STATIC,
      detailsInfo: {}
    }
  },
  mounted() {
    const { id } = this.$route.params
    this.getDetails(id)
  },
  methods: {
    async getDetails(id) {
      const { content: res } = await this.$http.post(
        '/portal/getRuinsById',
        qs.stringify({
          id
        })
      )
      console.log(res)
      this.detailsInfo = res
    }
  }
}
</script>

<style lang="less" scoped>
.top_info {
  width: 100%;
  video {
    width: 100%;
  }
  .item_img {
    width: 100%;
    height: 5.6rem;
  }
}
.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.6rem;
  .item_title {
    width: 80%;
    text-align: center;
    font-size: 0.6133rem;
    color: #222;
    line-height: 1.5;
    font-weight: bold;
    letter-spacing: 0.0533rem;
    margin-bottom: 0.4rem;
  }
  img {
    width: 6.1333rem;
  }
}
.item_content {
  padding: 0 0.4rem;
  margin-top: 0.4rem;
  margin-top: 0.3rem;
  font-size: 0.4267rem;
  color: #444;
  line-height: 2;
  text-indent: 2em;
}
</style>
